<template>
  <div v-if="show" class="ap-overlay" @click.self="$emit('close')">
    <div class="ap-modal">
      <div class="ap-scrollbar-cap is-top"></div>
      <div class="ap-scrollbar-cap is-bottom"></div>
      <div class="ap-modal-scroll">
        <div class="ap-modal-head">
          <h5 class="ap-modal-title">Client Details</h5>
          <button class="ap-modal-close" @click="$emit('close')">
            <fa-icon :icon="['fas', 'times']" />
          </button>
        </div>

        <div v-if="client" class="ap-detail-grid">
          <div class="ap-detail-row"><span class="ap-detail-label">ID</span><span class="ap-detail-val ap-mono">{{ client.id }}</span></div>
          <div class="ap-detail-row"><span class="ap-detail-label">Full Name</span><span class="ap-detail-val">{{ client.full_name }}</span></div>
          <div class="ap-detail-row"><span class="ap-detail-label">Email</span><span class="ap-detail-val">{{ client.email }}</span></div>
          <div class="ap-detail-row"><span class="ap-detail-label">Client</span><span class="ap-detail-val">{{ client.client || '-' }}</span></div>
          <div class="ap-detail-row">
            <span class="ap-detail-label">Status</span>
            <span class="ap-detail-val">
              <span class="ap-status-badge" :class="'ap-status-' + (client.status || 'active').toLowerCase()">
                {{ client.status || 'Active' }}
              </span>
            </span>
          </div>
          <div class="ap-detail-row"><span class="ap-detail-label">Created</span><span class="ap-detail-val">{{ client.created_at }}</span></div>
        </div>

        <div class="ap-doc-section">
          <div class="ap-doc-head">
            <span>Documents</span>
            <span v-if="documents.length" class="ap-doc-badge">{{ documents.length }}</span>
          </div>
          <div v-if="docsLoading" class="ap-doc-loading">
            <fa-icon :icon="['fas', 'spinner']" spin /> Loading…
          </div>
          <empty-state
            v-else-if="!documents.length"
            :icon="['fas', 'file']"
            icon-bg="#f3f4f6"
            icon-color="#9ca3af"
            title="No documents"
            message="No documents uploaded yet."
          />
          <div v-else class="ap-doc-list">
            <div v-for="doc in documents" :key="doc.id" class="ap-doc-item">
              <div class="ap-doc-icon" :class="'ap-doc-' + doc.file_type">
                <fa-icon :icon="docFileIcon(doc.original_name)" />
              </div>
              <div class="ap-doc-info">
                <span class="ap-doc-name">{{ doc.original_name }}</span>
                <span class="ap-doc-meta">{{ docFormatBytes(doc.file_size) }} · {{ formatDate(doc.uploaded_at) }} · <em>{{ doc.section }}</em></span>
              </div>
              <button class="ap-row-action" title="Download" @click="$emit('download-doc', doc)">
                <fa-icon :icon="['fas', 'download']" />
              </button>
              <button class="ap-row-action ap-row-action-danger" title="Delete" @click="$emit('delete-doc', doc.id)">
                <fa-icon :icon="['fas', 'trash']" />
              </button>
            </div>
          </div>
        </div>

        <button class="ap-btn ap-btn-ghost ap-btn-block" style="margin-top: 20px" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyState from '@/components/shared/EmptyState.vue'
import bodyScrollLockMixin from '@/mixins/bodyScrollLockMixin'

export default {
  name: 'admin-view-client-modal',
  mixins: [bodyScrollLockMixin],
  components: { EmptyState },
  props: {
    show: { type: Boolean, default: false },
    client: { type: Object, default: null },
    documents: { type: Array, default: () => [] },
    docsLoading: { type: Boolean, default: false }
  },
  emits: ['close', 'download-doc', 'delete-doc'],
  methods: {
    docFileIcon (filename) {
      const ext = (filename || '').split('.').pop().toLowerCase()
      if (ext === 'pdf') return ['fas', 'file-pdf']
      if (['jpg', 'jpeg', 'png'].includes(ext)) return ['fas', 'file-image']
      if (ext === 'csv') return ['fas', 'file-csv']
      return ['fas', 'file']
    },
    docFormatBytes (bytes) {
      if (!bytes) return '0 B'
      if (bytes < 1024) return `${bytes} B`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
    },
    formatDate (str) {
      if (!str) return '-'
      const d = new Date(str)
      if (isNaN(d)) return str
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    }
  }
}
</script>
